export default __webpack_public_path__ + "static/media/appraise4.fa992464.png";